export const SHIPPING_TYPES = Object.freeze({
  DROPSHIP: 'dropship',
  FLORIST: 'florist',
  MIXED: 'mixed'
});